import { render, staticRenderFns } from "./RichEditor.vue?vue&type=template&id=47b04b6e&scoped=true"
import script from "./RichEditor.vue?vue&type=script&lang=js"
export * from "./RichEditor.vue?vue&type=script&lang=js"
import style0 from "./RichEditor.vue?vue&type=style&index=0&id=47b04b6e&prod&lang=scss&scoped=true"
import style1 from "./RichEditor.vue?vue&type=style&index=1&id=47b04b6e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b04b6e",
  null
  
)

export default component.exports